export default __webpack_public_path__ + "static/media/ba10.b3b941a2.jpg";